const DontLogin = () => {
    return (
        <div>
            <h3>Войдите для доступа к личному кабинету</h3>
        </div>
    )
}

export default DontLogin;